export default __webpack_public_path__ + "static/media/principal.dd03bc51.jpg";